import { computed, defineComponent } from '@vue/composition-api';
import { HelpdeskRoutes } from '@/Helpdesk/helpdesk.const';
import { useGetLocalizedPath } from '@/util/globalHelpers';
import { imageUrl, imageSrcSet } from '@/util/images';
export default defineComponent({
    props: {
        category: {
            type: Object,
            required: true
        }
    },
    setup(props, context) {
        const { root } = context;
        // The category image is an i18n STRING, so it can be a local /img path or
        // a remote one depending on the locale file. imageUrl decides per URL
        // rather than the component guessing.
        const source = computed(() => root.$i18n.t(`helpdesk.categories.${props.category.slug}.image`));
        const categoryImage = computed(() => imageUrl(source.value, { width: 380, height: 240, crop: 'c-at_least' }));
        const categorySrcSet = computed(() => imageSrcSet(source.value, [290, 380, 760], {
            crop: 'c-at_least',
            aspect: 380 / 240
        }));
        return {
            categoryImage,
            categorySrcSet,
            HelpdeskRoutes,
            useGetLocalizedPath
        };
    }
});
